

import { ERROR_CODES } from '@yggdrasil/Checkout/V2/Services/checkout-critical-errors'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutConfigurationErrorV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}


  errorMessageMapping = {
    [ERROR_CODES.EMPTY_PAYMENT_METHODS_ERROR]: `<a href="https://support.myclickfunnels.com/docs/getting-started-setting-up-payments-in-clickfunnels" target="_blank">${this.checkoutConfigurationErrorsTexts.emptyPaymentMethodsError}</a>`,
    [ERROR_CODES.EMPTY_PRODUCTS_ERROR]: this.checkoutConfigurationErrorsTexts.emptyProductsError,
    [ERROR_CODES.ORDER_RECURRING_INTERVAL_MISMATCH]: this.checkoutConfigurationErrorsTexts.orderRecurringIntervalMismatchError,
    [ERROR_CODES.MULTIPLE_CHECKOUT_PRESENT]: this.checkoutConfigurationErrorsTexts.multipleCheckoutPresentError,
  }

  mount() {
    const prettifyErrorMessage = (error) => {
      if (this.errorMessageMapping[error.code]) return this.errorMessageMapping[error.code]

      if (error.fetchErrorType == CFFetcherErrorTypes.NETWORK_ERROR) {
       return `${this.checkoutConfigurationErrorsTexts.networkError} ${error.code}`  
      } else {
        // TODO: When we have bugsnag support, change this error message to:
        // Add A critical server error occurred during checkout. Tech support has been notified and will investigate. Please retry later, and/or contact support at ...
        return  `${this.checkoutConfigurationErrorsTexts.criticalServerError} ${error.code}`
      }
    }

    Checkout.store?.criticalErrors?.subscribe((errors) => {
      this.errors = errors.map(prettifyErrorMessage);
      this.render()
    });
  }

  setErrors(errors: string | string[]) {
    if(errors === null || typeof errors === 'undefined') {
      return
    }
    this.errors = Array.isArray(errors) ? errors : [errors]
    this.render()
  }


    remove() {
      this.element.innerHTML = '';
    }
    render(initializeChildrenInstances = false) {
      const is_server = true;
      const errors = this.errors ?? [] ;
const checkoutConfigurationErrorsTexts = this.checkoutConfigurationErrorsTexts ?? null ;

      
      let html = '';
      {
        html += `<div class="elCheckoutConfigError`
        if (errors?.length == 0) {
          html += ` elHide`
        }
        html += `">`
        const c0 = errors
        const fl1 = new CF2ForloopDrop(c0.length)
        for (const error of c0) {
          const forloop = fl1
          html += `<span>${error}</span>`
          forloop.next();
        }
        html += `</div>`

      }

      this.replaceContent(html) 

      if (initializeChildrenInstances) {
        const scopeToYggRender = this.element.querySelectorAll('[ygg-render]').length > 0;
        const options = { scopeToYggRender };
        CF2Component.hydrateTree(this.element, options);
      }
    }


}

registerComponent('CheckoutConfigurationError/V1', CheckoutConfigurationErrorV1)
window["CheckoutConfigurationErrorV1"] = CheckoutConfigurationErrorV1

